const topics = [
  { tag: '热门影视', heat: '98.6万', trend: 'up', color: 'bg-primary-100 text-primary-700' },
  { tag: '娱乐综艺', heat: '87.2万', trend: 'up', color: 'bg-accent-100 text-accent-700' },
  { tag: '纪录片', heat: '65.4万', trend: 'up', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '动漫番剧', heat: '72.8万', trend: 'hot', color: 'bg-primary-100 text-primary-700' },
  { tag: '体育赛事', heat: '54.1万', trend: 'up', color: 'bg-accent-100 text-accent-700' },
  { tag: '知识科普', heat: '43.7万', trend: 'new', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '音乐现场', heat: '38.5万', trend: 'up', color: 'bg-primary-100 text-primary-700' },
  { tag: '游戏实况', heat: '61.3万', trend: 'hot', color: 'bg-accent-100 text-accent-700' },
  { tag: '短剧合集', heat: '89.9万', trend: 'hot', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            全网用户正在关注的热点内容方向
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.tag}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${topic.color} text-sm font-medium cursor-default transition-transform hover:scale-105`}
            >
              <span className="whitespace-nowrap">{topic.tag}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.heat}</span>
              {topic.trend === 'hot' && (
                <i className="ri-fire-line text-xs text-primary-500"></i>
              )}
              {topic.trend === 'new' && (
                <i className="ri-sparkling-line text-xs text-accent-500"></i>
              )}
              {topic.trend === 'up' && (
                <i className="ri-arrow-up-line text-xs"></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}